<template>
    <el-dialog
        :title="title"
        :visible="value"
        :width="isDaily ? '600px': '510px'"
        :modal-append-to-body="false"
        :close-on-click-modal="true"
        @close="close"
    >
        <el-form :model="topicSetForm" :rules="topicSetRules" class="topicSet-form" ref="topicSetForm"
                 @submit.native.prevent
                 size="medium"
                 label-width="140px">
            <el-form-item label="题组名称：" prop="name">
                <el-input v-model="topicSetForm.name" ref="nameInput"
                          @keyup.enter.native="saveTopicSetForm"
                          :placeholder="$t('tip.name')" clearable></el-input>
            </el-form-item>

            <!-- 个人题组专属 -->
            <el-form-item label="题组权限：" class="policy-item" prop="policy" v-if="isPersonal">
                <el-radio-group v-model="topicSetForm.policy" size="small">
                    <el-radio-button :label="0"><i class="nucfont inuc-password2"></i>私有</el-radio-button>
                    <el-radio-button :label="1"><i class="nucfont inuc-watch"></i>共享只读</el-radio-button>
                    <el-radio-button :label="2"><i class="nucfont inuc-public"></i>共享编辑</el-radio-button>
                </el-radio-group>
                <div class="policy-note">
                    <span v-if="topicSetForm.policy === 0">仅自己可以查看和编辑</span>
                    <span v-if="topicSetForm.policy === 1">开放查看，仅自己可编辑</span>
                    <span v-if="topicSetForm.policy === 2">开放查看和编辑</span>
                </div>
            </el-form-item>

            <!-- 每日一练专属 -->
            <template v-if="isDaily">
                <el-form-item label="每题分值：" prop="topicPoint">
                    <el-input-number v-model="topicSetForm.topicPoint" :min="1" :max="50" controls-position="right"></el-input-number>
                </el-form-item>

                <el-form-item label="每日积分上限：" prop="dailyLimit">
                    <el-input-number v-model="topicSetForm.dailyLimit" :min="0" :max="10000" :step="10" controls-position="right"></el-input-number>
                </el-form-item>

                <el-form-item label="题目生效时段：" prop="time">
                    <el-date-picker
                        v-model="topicSetForm.time"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        :range-separator="$t('c.to')"
                        :start-placeholder="$t('c.startTime')"
                        :end-placeholder="$t('c.endTime')">
                    </el-date-picker>
                </el-form-item>

                <el-form-item prop="singleModeLimited">
                    <el-tooltip slot="label" class="item" effect="dark" content="若设置题数为n，则每日只能进行一次题数为n的练习" placement="top-end">
                        <p>每日题数限制<i class="icon-tip el-icon-info"></i>：</p>
                    </el-tooltip>
                    <el-switch v-model="isSingleModeLimited"></el-switch>
                    <div class="limit-number-setting" v-show="isSingleModeLimited">
                        <el-input-number
                            v-model="topicSetForm.singleModeLimited"
                            :min="0"
                            :max="data.size || 1000"
                            :precision="0"
                            size="mini"
                            controls-position="right"></el-input-number> 题
                    </div>
                </el-form-item>
                <el-form-item prop="topicTimeLimit">
                    <el-tooltip slot="label" class="item" effect="dark" content="单题答题时间最小时间限制是5s,最大是120s" placement="top-end">
                        <p>单题时间限制<i class="icon-tip el-icon-info"></i>：</p>
                    </el-tooltip>
                    <el-switch v-model="isTopicTimeLimit"></el-switch>
                    <div class="limit-number-setting" v-show="isTopicTimeLimit">
                        <el-input-number
                            v-model="topicSetForm.topicTimeLimit"
                            :min="5"
                            :max="120"
                            :precision="0"
                            size="mini"
                            controls-position="right"></el-input-number> 秒
                    </div>
                </el-form-item>
            </template>

            <el-form-item label="考题类型：" class="topic-type-item" prop="topicType">
                <el-radio-group v-model="topicSetForm.topicType" :disabled="currentID" size="small">
                    <el-radio-button :label="1">理论</el-radio-button>
                    <el-radio-button :label="4">DR</el-radio-button>
                    <el-radio-button :label="3">CT</el-radio-button>
                </el-radio-group>
            </el-form-item>

            <!-- 每日一练中图像的练习模式 -->
            <el-form-item v-if="isDaily && (topicSetForm.topicType === 4 || topicSetForm.topicType === 3)"
                          label="练习模式：" prop="pattern">
                <el-radio-group v-model="topicSetForm.pattern" size="small">
                    <el-radio-button :label="null">不限制</el-radio-button>
                    <el-radio-button v-for="item in patterns" :label="item.id" :key="item.id">{{item.value}}</el-radio-button>
                </el-radio-group>
            </el-form-item>

            <el-form-item :label="$t('c.desc')+'：'" prop="content">
                <el-input type="textarea" v-model="topicSetForm.content"
                          :autosize="{minRows:3,maxRows:4}"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" style="text-align: center;margin-bottom: 10px">
            <el-button type="primary" @click="saveTopicSetForm" :loading="submitLoading">{{ $t('c.save') }}
            </el-button>
        </div>
    </el-dialog>
</template>

<script>

export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        currentID: {
            required: true
        },
        type: {
            type: Number,
            default: 2
        }
    },

    data() {
        return {
            data: {},
            topicSetForm: {
                name: '',
                topicType: 1,
                content: '',
                policy: 0,
                topicPoint: 0,
                dailyLimit: 0,
                time: [],
                pattern: null,
                singleModeLimited: null,
                topicTimeLimit: null
            },
            topicSetRules: {
                name: [
                    {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                    {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'}
                ],
                // topicType: [
                //     {required: true, message: '请选择考题类型', trigger: 'change'},
                // ],
                topicPoint: [
                    {required: true, message: '请输入每题分值', trigger: 'change'}
                ],
                dailyLimit: [
                    {required: true, message: '请输入每日积分上限', trigger: 'change'},
                    {validator: this.dailyLimitValidator, trigger: 'blur'}
                ],
                time: [
                    {required: true, message: '请选择题目生效时间段', trigger: 'change'}
                ],
                content: [
                    {max: 500, message: this.$t('rule.maxLength', ['500']), trigger: 'blur'},
                ],
            },
            submitLoading: false,
            isSingleModeLimited: false,
            isTopicTimeLimit: false,
            patterns: []
        }
    },

    computed: {
        title() {
            if (this.currentID) {
                return '编辑题组信息'
            } else if (this.type === 1) {
                return '添加背题题组'
            } else if (this.type === 2) {
                return '添加个人题组'
            } else {
                return '添加题组'
            }
        },
        isPersonal() {
            return this.type === 2
        },
        isDaily() {
            return this.type === 3
        }
    },
    watch: {
        value(val) {
            // 打开
            this.isTopicTimeLimit = false
            if (val) {
                this.initDialog();
            }
        },

        'topicSetForm.singleModeLimited'(v) {
            this.isSingleModeLimited = !!v
        },
        // 'topicSetForm.topicTimeLimit'(v) {
        //     this.isTopicTimeLimit = !!v
        // }
    },

    mounted() {
        if (this.isDaily) {
            this.$api.getPaperPattern().then(res => {
                this.patterns = res.package;
            })
        }
    },

    methods: {
        initDialog() {
            this.resetForm()

            // 如果不加nextTick，先点编辑，再点添加，则初始化数据永远记为编辑数据了
            this.$nextTick(() => {
                if (this.currentID) {
                    let data = this.$parent.tableData.find(ele => ele.id === this.currentID);

                    this.data = data

                    for (let item in data) {
                        if (this.topicSetForm.hasOwnProperty(item)) {
                            if (item === 'startTime' || item === 'endTime') {
                                return
                            }

                            this.topicSetForm[item] = data[item]
                            console.log(11111111111);
                            this.isTopicTimeLimit = !this.topicSetForm.topicTimeLimit ? false: true
                        }
                    }

                    this.topicSetForm.time = [data.startTime, data.endTime]

                } else {
                    this.$refs.nameInput.$refs.input.focus()
                    this.data = {}
                }
            })

        },

        dailyLimitValidator(rule, value, callback) {
            if (value === 0) {
                return callback(new Error('请输入每日积分上限'))
            }
            if (value < this.topicSetForm.topicPoint) {
                return callback(new Error('积分上限不能低于每题分值'))
            }

            callback()
        },

        resetForm() {
            this.$refs['topicSetForm'] && this.$refs['topicSetForm'].resetFields()

            // this.topicSetForm.name = ''
            // this.topicSetForm.topicType = 1
            // this.topicSetForm.content = ''
            // this.topicSetForm.policy = 0
            // this.topicSetForm.topicPoint = 0
            // this.topicSetForm.dailyLimit = 0
            // this.topicSetForm.time = []
        },

        async saveTopicSetForm() {
            this.$refs['topicSetForm'].validate((valid) => {
                if (!valid) return;

                let submitData = {
                    name: this.topicSetForm.name,
                    topicType: this.topicSetForm.topicType,
                    content: this.topicSetForm.content,
                    type: this.type
                }

                if (this.isPersonal) {
                    submitData.policy = this.topicSetForm.policy
                }

                if (this.isDaily) {
                    submitData.daily = {
                        topicPoint: this.topicSetForm.topicPoint,
                        dailyLimit: this.topicSetForm.dailyLimit,
                        startTime: this.topicSetForm.time[0],
                        endTime: this.topicSetForm.time[1],
                        singleModeLimited: this.isSingleModeLimited ? (this.topicSetForm.singleModeLimited || null) : null,
                        topicTimeLimit: this.isTopicTimeLimit ? (this.topicSetForm.topicTimeLimit || null) : null,
                        pattern: this.topicSetForm.pattern,
                    }
                }

                this.submitLoading = true;

                if (this.currentID) {
                    this.$api.editTopicSet(this.currentID, submitData).then(res => {
                        this.close()
                        this.submitLoading = false
                        this.$message.success(this.$t('m.editSuccess'));
                        this.$emit('success')
                    }).catch(error => this.submitLoading = false);
                } else {
                    this.$api.postTopicSet(submitData).then(res => {
                        this.close()
                        this.submitLoading = false
                        this.$message.success(this.$t('m.addSuccess'));
                        this.$emit('success')
                    }).catch(error => this.submitLoading = false);
                }

            });
        },

        close() {
            this.$emit('input', false)
        }
    },
}
</script>

<style scoped lang="scss">

.policy-item {
    .nucfont {
        margin-right: 4px;
        font-size: 14px;
    }

    .policy-note {
        margin-top: 10px;
        font-size: 12px;
        color: #9f9f9f;
        line-height: 1;
    }
}

.limit-number-setting {
    display: inline-block;
    .el-input-number {
        margin-left: 12px;
        margin-right: 4px;
    }
}

.icon-tip {
    padding-left: 3px;
    font-size: 16px;
    vertical-align: middle;
    color: #999;
}

.topic-type-item {
    /deep/ .el-radio-button__inner {
        padding: 10px 15px;
    }
}


</style>
